<div
  [class]="elementClasses"
  ngClass="widtget-editor-text"
  [innerHTML]="widget?.Texto"
></div>
